import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowUp, Sparkles } from "lucide-react";

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isNearContact, setIsNearContact] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.6;
      setIsVisible(window.scrollY > heroHeight);
      setShowScrollTop(window.scrollY > window.innerHeight * 1.5);
      
      // Hide when near contact section to avoid redundancy
      const contactSection = document.getElementById("contact-section");
      if (contactSection) {
        const rect = contactSection.getBoundingClientRect();
        setIsNearContact(rect.top < window.innerHeight * 0.8 && rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById("contact-section")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Don't show when near contact form
  if (isNearContact) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:right-6 sm:bottom-6"
        >
          <div className="flex items-center justify-between sm:justify-end gap-3">
            {/* Scroll to top - Hidden on mobile to save space */}
            <AnimatePresence>
              {showScrollTop && (
                <motion.div
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                  className="hidden sm:block"
                >
                  <Button
                    size="icon"
                    variant="outline"
                    onClick={scrollToTop}
                    className="h-10 w-10 sm:h-12 sm:w-12 rounded-full shadow-lg bg-background/95 backdrop-blur-sm border-border hover:border-primary/50"
                  >
                    <ArrowUp className="h-4 w-4 sm:h-5 sm:w-5" />
                  </Button>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Main CTA Button - Full width on mobile */}
            <Button
              size="lg"
              onClick={scrollToContact}
              className="flex-1 sm:flex-none h-12 sm:h-14 px-4 sm:px-8 rounded-full shadow-xl shadow-primary/30 bg-gradient-to-r from-primary to-primary/90 hover:shadow-2xl hover:shadow-primary/40 transition-all duration-300 active:scale-95 sm:hover:scale-105 text-sm sm:text-lg font-semibold"
            >
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
              Get Free Quote
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;
